<template>
  <div class="shrink-0 bg-white border-b border-slate-200 px-6 flex items-center gap-1">
    <router-link
      v-for="t in tabs"
      :key="t.to"
      :to="t.to"
      custom
      v-slot="{ navigate, isActive }"
    >
      <button
        type="button"
        class="relative py-3.5 px-4 text-sm font-medium transition-colors duration-200 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-indigo-300 rounded-t"
        :class="isActive ? activeTextClass(t.variant) : 'text-slate-500 hover:text-slate-700'"
        @click="navigate"
      >
        {{ t.label }}
        <span
          v-if="isActive"
          :class="['absolute bottom-0 left-0 right-0 h-0.5 rounded-full', activeBarClass(t.variant)]"
          aria-hidden="true"
        />
      </button>
    </router-link>
  </div>
</template>

<script>
// variant → Tailwind class map（保留 literal 讓 Tailwind JIT 能掃到）
const VARIANT_TEXT = {
  indigo: 'text-indigo-600',
  teal: 'text-teal-600',
  violet: 'text-violet-600'
}
const VARIANT_BAR = {
  indigo: 'bg-indigo-500',
  teal: 'bg-teal-500',
  violet: 'bg-violet-500'
}

export default {
  name: 'PermissionSubTabs',
  computed: {
    tabs () {
      return [
        { to: '/permission/users', label: this.$t('permission_users_page_title'), variant: 'indigo' },
        { to: '/permission/roles', label: this.$t('permission_roles_page_title'), variant: 'teal' },
        { to: '/permission/resources', label: this.$t('permission_resources_page_title'), variant: 'violet' }
      ]
    }
  },
  methods: {
    activeTextClass (variant) {
      return VARIANT_TEXT[variant] || VARIANT_TEXT.indigo
    },
    activeBarClass (variant) {
      return VARIANT_BAR[variant] || VARIANT_BAR.indigo
    }
  }
}
</script>
